import SettingsPage from './settings-page.connect'

export default SettingsPage



// WEBPACK FOOTER //
// ./src/components/views/settings-page/index.js